import { Box, Button, Paper } from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import AddCircleOutlineRoundedIcon from "@mui/icons-material/AddCircleOutlineRounded";
import styles from "./Home.module.scss";
import { useTranslation } from "react-i18next";
import MainContext from "../../context/mainContext";
import MyPublications from "../publications/MyPublications";
import { useNavigate } from "react-router";
import NewPublicationDialog from "./NewPublicationDialog";
import LastPublications from "../publications/LastPublications";
import SearchForm from "../publications/Search/SearchForm";
import { PublicationAdvancedFilter } from "../../misc/pagedFilter";
import { useSessionStorageWithObject } from "../../hooks/useSessionStorage";

const Home: React.FC = () => {
  const { t } = useTranslation();
  const { currentUser, setBanner, setBannerLink } = useContext(MainContext);
  const [showNewPublication, setShowNewPublication] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    setBanner("banner-home.png");
    setBannerLink(process.env.REACT_APP_HOME_BANNER_LINK || "");
  });

  const onClickCreatePublication = () => {
    setShowNewPublication(true);
  };

  const onContinue = () => {
    setShowNewPublication(false);
    navigate("/new-publication");
  };

  const initFilter: PublicationAdvancedFilter = {
    pageNumber: 1,
    pageSize: 10,
    sortField: "title",
    sortDescending: false,
    search: "",
    criteria: 0,
    status: "",
    topics: [],
    filterBy: "byDivision",
    divisions: [],
    departments: [],
    countries: [],
    languages: [],
    fromDate: null,
    toDate: null,
  };

  const [currentFilter, setCurrentFilter] =
    useSessionStorageWithObject<PublicationAdvancedFilter>(
      `search_filters`,
      initFilter
    );

  const handleSearch = (search: string, criteria: Number) => {
    setCurrentFilter({
      ...initFilter,
      search: search,
      criteria: criteria,
    });
    navigate("search");
  };

  return (
    <div className={styles.homePage}>
      <div className={`${styles.homeRow} ${styles.homeSearchRow}`}>
        <SearchForm handleSearch={handleSearch} />
      </div>
      <div className={styles.homeRow}>
        <Box className={styles.home}>
          <Paper elevation={3} className={styles.welcome}>
            <h3>{t("welcome", { userName: currentUser?.displayName })}</h3>
            <p>{t("welcomeMessage")}</p>

            <Box>
              <Button onClick={onClickCreatePublication}>
                <AddCircleOutlineRoundedIcon />
                {t("createNewPublication")}
              </Button>
            </Box>
          </Paper>
          <NewPublicationDialog
            open={showNewPublication}
            onContinue={onContinue}
            onCancel={() => setShowNewPublication(false)}
          />
        </Box>
        <LastPublications status="published" />
      </div>
      <div className={styles.homeRow}>
        <MyPublications />
        <LastPublications status="inProgress" />
      </div>
    </div>
  );
};

export default Home;
